import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=0806c879"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=0806c879&prod&lang=sass"
import style1 from "./PaymentMethods.vue?vue&type=style&index=1&id=0806c879&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports